export default __webpack_public_path__ + "static/media/solarp.29fa95b6.jpg";